import React, { useEffect, useState } from "react";
import "./HomeCarousel.css";

import video6 from "../../../assets/sliderImages/video6.mp4";
import carouselImage from "../../../assets/images/siemens.png";

const textSlides = [
  "We expertise in Teamcenter PLM, Polarion ALM, Opcenter MES, Mendix Apps & SaaS Solutions",
  "Enhance Profitability and Efficiency by Speeding Up Digital Transformation",
  "Expand the PLM Ecosystem Across the Extended Enterprise",
];

const HomeCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      // start fade-out
      setFade(true);

      // change text quickly (no lag)
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % textSlides.length);

        // fade-in back
        setFade(false);
      }, 250); // must match CSS transition time
    }, 3000); // change every 3 seconds (faster + smoother)

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel hero-carousel-root">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <div className="carousel-video">
            <video
              src={video6}
              autoPlay
              loop
              muted
              playsInline
              className="hero-video"
            />

            <div className="caption-image">
              <img src={carouselImage} alt="Siemens Solution Partner" />
            </div>

            <div className="carousel-caption hero-caption-center">
              <div className={`caption-text ${fade ? "fade" : ""}`}>
                <h1>PLM Implementation</h1>
                <p>{textSlides[currentSlide]}</p>
              </div>
            </div>

            <div className="hero-overlay" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeCarousel;
